import { combineReducers } from "redux"

import optionsReducer from "./options/options.reducer"
import estimationsReducer from "./estimations/estimations.reducer"
import categoriesReducer from "./categories/categories.reducer"
import platformsReducer from "./platforms/platforms.reducer"
import userReducer from "./user/user.reducer"
import configurationReducer from "./configuration/configuration.reducer"

const rootReducer = combineReducers({
  estimations: estimationsReducer,
  options: optionsReducer,
  categories: categoriesReducer,
  platforms: platformsReducer,
  user: userReducer,
  configuration: configurationReducer,
})

export default rootReducer
